import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { Search } from 'src/common/components';

import { CampaignDetailList } from '../components/CampaignDetailList';

export const CampaignDetailsList = (): JSX.Element => {
  const navigate = useNavigate();
  const listRef = useRef<any>(null);
  const [filter, setFilter] = useState('');

  const handleShowAdd = (): void => {
    navigate('/app/tcr/campaign_details/create');
  };

  const handleShowEdit = (item: any): void => {
    navigate(`/app/tcr/campaign_details/${item.id}`);
  };

  return (
    <div className="flex flex-col p-8" style={{ height: 'calc(100vh - 66px)' }}>
      <div className="flex items-center pb-4">
        <h2 className="sm:px-0 flex-1">Campaign details</h2>
        <Search setSearch={setFilter} placeholder="Search..." className="max-w-sm ml-auto" />
        <button
          className="sm:flex btn btn-secondary hidden ml-4"
          type="button"
          onClick={handleShowAdd}
        >
          <p className="text-white-0.0 font-semibold"> Create campaign details</p>
        </button>
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto">
        <CampaignDetailList query={filter} onEdit={handleShowEdit} forwardRef={listRef} />
      </div>
    </div>
  );
};
